export const en = {
    tariff_choose: 'Choose tariff',
};
